<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">开票信息管理</span>
                        <Button type="success"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="searchCompany()">企业信息查询</Button>
                        <span style="color:grey;">网址:http://gsxt.gdgs.gov.cn</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
		<InvoiceAccountModal ref="invoiceAccountModal" @RefreshList="getMainTableRecords" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateRender } from '@/libs/tableRowTimeRender';
import { singleImageRender } from '@/libs/tableRowImageRender';
import { getInvoiceAccountList, auditInvoiceAccount } from '@/api/modules/finance-management/invoice';
import InvoiceAccountModal from './invoice-account-modal.vue';

export default {
    name: 'QualifyFailReportList',
    components: {
        StandPaginationTable,
        SearchCard,
        InvoiceAccountModal
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '会员账号', key: 'invoiceAccountUserName', width: 80, align: 'center' },
                    { title: '会员名称', key: 'invoiceAccountUserPersonName', width: 120, align: 'center' },
                    { title: '发票抬头', key: 'invoiceAccountBuyerName', width: 120, align: 'center' },
                    { title: '统一社会信用代码', key: 'invoiceAccountBuyerTaxNum', width: 160, align: 'center' },
                    { title: '开户银行名称', key: 'invoiceAccountBuyerBank', width: 160, align: 'center' },
                    { title: '基本开户账号', key: 'invoiceAccountBuyerAccount', width: 160, align: 'center' },
                    { title: '注册场所地址', key: 'invoiceAccountBuyerAddress', width: 160, align: 'center' },
                    { title: '注册固定电话', key: 'invoiceAccountBuyerTel', width: 100, align: 'center' },
                    { title: '营业执照', width: 80, align: 'center', render: (h, params) => singleImageRender(h, params.row.invoiceAccountLicenseImage) },
                    { title: '创建时间', width: 80, key: 'invoiceAccountCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.invoiceAccountCreateAt) },
                    //{ title: '审批状态', key: 'invoiceAccountStatus', width: 80, align: 'center' },
                    { title: '最后修改人', key: 'invoiceAccountAuditorName', width: 80, align: 'center' },
                    { title: '修改时间', width: 80, key: 'invoiceAccountAuditAt', align: 'center', render: (h, params) => dateRender(h, params.row.invoiceAccountAuditAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                /*h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        display: params.row.invoiceAccountStatus !== '已审批' ? 'inline' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.auditAccount(params.row);
                                            // this.$refs.qualifyFailReportDetailModal.showModal(params.row.qualifyFailReportRecordUuid);
                                        }
                                    }
                                }, '审批'),*/
                                
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        display: 'inline'
                                    },
                                    on: {
                                        click: () => {
                                            this.editAccount(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '会员', type: 'Input', value: '', name: 'concat(invoiceAccountUserName,invoiceAccountUserPersonName)', sql: 'like' },
                    { label: '信用代码', type: 'Input', value: '', name: 'invoiceAccountBuyerTaxNum', sql: 'like' },
                    { label: '创建时间', type: 'Daterange', value: '', name: 'invoiceAccountCreateAt', sql: 'dateBetween' }
                ]
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        searchCompany() {
            window.open("http://gsxt.gdgs.gov.cn", "_blank");
        },
        auditAccount(row) {
            this.$Modal.confirm({
                title: '确认通过审批？',
                onOk: () => {
                    this.mainTable.tableLoading = true;
                    auditInvoiceAccount({ invoiceAccountUuid: row.invoiceAccountUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.init();
                            this.$Message.success('审批成功');
                        }
                    });
                }
            });

        },
        editAccount(row) {
            this.$refs.invoiceAccountModal.showModalByEntity(row);
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getInvoiceAccountList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
